import searchAtomPair, { SearchParams } from 'atoms/search-atom';
import type { PriceDeckResult, PriceDeckFacets } from './types';

/** Search parameters for the Price Decks list query. */
export interface PriceDeckParams extends SearchParams {
  methodType?: string[];
  status?: string[];
  stripDateMode?: string;
  stripPriceDate?: string;
  createdBy?: string[];
  createdAt?: {
    start?: string;
    end?: string;
  };
}

/**
 * Creates a search atom pair for the Price Decks list query.
 * POST to /queries/price_decks
 * @return {object} Search atom pair.
 */
export const createPriceDeckSearchAtom = () => {
  return searchAtomPair<PriceDeckResult, PriceDeckParams, PriceDeckFacets>({
    href: '/queries/price_decks',
  });
};
